export default "__VITE_ASSET__CT3n6cn3__"